/* eslint-disable react/require-default-props */
import React, { MouseEventHandler } from 'react';
import backIcon from 'assets/icons/common/back.svg';
import Tooltip from '../tooltip';

type BackButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  styles?: string;
};

export default function BackButton({ onClick, styles }: BackButtonProps) {
  return (
    <Tooltip message="Back" styles="whitespace-nowrap">
      <button type="button" onClick={onClick} className={`mt-1 h-4 w-4 sm:w-5 sm:h-5 my-4 ${styles}`}>
        <div className="flex justify-center items-center">
          <img src={backIcon} alt="Back" />
          <div className="h-fit text-lg">Back</div>
        </div>
      </button>
    </Tooltip>
  );
}
